import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

const ProgressIndicator = props => {
  const progressSteps = _.range(props.steps).map((item, i) => (
    <span
      className={'progress-item ' + (props.active === i + 1 ? 'is-active' : '')}
      key={i}
    />
  ))
  return (
    <div className='progress-indicator' style={props.style}>
      {progressSteps}
    </div>
  )
}

ProgressIndicator.propTypes = {
  steps: PropTypes.number,
  active: PropTypes.number
}

export default ProgressIndicator



// WEBPACK FOOTER //
// ./src/ui/progress-indicators/progress-indicator.js